import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { AppShell } from './components/layout/AppShell';
import { RedirectIfAuthed, RequireAuth } from './components/layout/RequireAuth';
import { Toaster } from './components/ui/Toast';
import { useAuth } from './store/authStore';

const AuthPage = lazy(() => import('./features/auth/AuthPage').then((m) => ({ default: m.AuthPage })));
const BillingPage = lazy(() => import('./features/billing/BillingPage').then((m) => ({ default: m.BillingPage })));
const BrandKitPage = lazy(() => import('./features/brand/BrandKitPage').then((m) => ({ default: m.BrandKitPage })));
const CreatePage = lazy(() => import('./features/create/CreatePage').then((m) => ({ default: m.CreatePage })));
const DashboardPage = lazy(() => import('./features/dashboard/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const EditorPage = lazy(() => import('./features/editor/EditorPage').then((m) => ({ default: m.EditorPage })));
const LandingPage = lazy(() => import('./features/marketing/LandingPage').then((m) => ({ default: m.LandingPage })));
const ProjectsPage = lazy(() => import('./features/projects/ProjectsPage').then((m) => ({ default: m.ProjectsPage })));
const SettingsPage = lazy(() => import('./features/settings/SettingsPage').then((m) => ({ default: m.SettingsPage })));
const TemplatesPage = lazy(() => import('./features/templates/TemplatesPage').then((m) => ({ default: m.TemplatesPage })));
const CommunityPage = lazy(() => import('./features/community/CommunityPage').then((m) => ({ default: m.CommunityPage })));
const LegalPage = lazy(() => import('./features/legal/LegalPage').then((m) => ({ default: m.LegalPage })));
const ContactPage = lazy(() => import('./features/legal/LegalPage').then((m) => ({ default: m.ContactPage })));

export function App() {
  useEffect(() => {
    void useAuth.getState().init();
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<div className="grid h-full place-items-center text-sm text-mute">Loading…</div>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<LegalPage policy="terms" />} />
        <Route path="/privacy" element={<LegalPage policy="privacy" />} />
        <Route path="/refunds" element={<LegalPage policy="refunds" />} />
        <Route path="/cancellation" element={<LegalPage policy="cancellation" />} />
        <Route path="/billing-policy" element={<LegalPage policy="billing" />} />
        <Route path="/acceptable-use" element={<LegalPage policy="acceptable" />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route
          path="/auth"
          element={
            <RedirectIfAuthed>
              <AuthPage />
            </RedirectIfAuthed>
          }
        />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/brand" element={<BrandKitPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/community" element={<CommunityPage />} />
        </Route>
        <Route
          path="/editor/:projectId"
          element={
            <RequireAuth>
              <EditorPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
      <Toaster />
    </BrowserRouter>
  );
}
